import apiFetch from './client';

export function suggestExercise(name, difficulty, equipment_needed) {
  return apiFetch('/api/ai/suggest-exercise', {
    method: 'POST',
    body: JSON.stringify({ name, difficulty, equipment_needed }),
  });
}

// Beispiel-Durchlauf mit den gerade eingestellten (ungespeicherten) Werten.
// payload: { use_case: 'text'|'image', provider, model, prompt, sample_name, difficulty?, equipment_needed? }
export function previewAi(payload) {
  return apiFetch('/api/ai/preview', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
